import React, { useEffect, useState } from 'react';
import styles from './TableCommponent.module.css';
import leftArrow from '../../../../assets/Imagess/downarrow.svg';
import Loader from '../../Loader/Loader';
import { formatFunction } from './TableFunctions';
import CheckBox from '../../../Atoms/Inputs/CheckBox';
import checkedicon from '../../../../assets/Imagess/tableiconheadgreen.svg';
import moreInfo from '../../../../assets/icons/programs/major/moreInfo.svg';
import editSvg from '../../../../assets/icons/formActions/edit.svg';
import deleteSvg from '../../../../assets/icons/formActions/delete.svg';
import { Pagination } from 'react-bootstrap';
import MoreButton from '../../Custom/MoreButton';
import PopOver from '../../Custom/PopOver/PopOver';
import NoDataComponent from '../../Custom/NoDataComponent/NoDataComponent';

const TableComponent = ({
  editAdd,
  selected,
  setSelected,
  page,
  setPage,
  setOrderBy,
  setOrderDir,
  orderDir,
  orderBy,
  pageSize,
  setPageSize,
  visibleColumn,
  columnVisibility,
  handleRowClick,
  tableData,
  handleEditClick,
  handleDelete,
  checkBox,
  pagination,
  additionalIcon,
}) => {
  const [arrowRotation, setArrowRotation] = useState('');
  const itemsPerPage = tableData?.pageSize;
  const totalItems = tableData?.totalCount;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const [checked, setChecked] = useState(false);
  const [isAllChecked, setIsAllChecked] = useState(true);

  const handleCheckboxClick = (e, itemid) => {
    setChecked(selected?.includes(itemid));
    e.stopPropagation();
  };
  useEffect(() => {
    if (selected?.length !== 0) {
      setIsAllChecked(false);
    } else {
      setIsAllChecked(true);
    }
  }, [selected]);

  const toggleCheckUser = (itemId) => {
    if (checked) {
      setSelected((prevSelectedApplicants) =>
        prevSelectedApplicants.filter((id) => id !== itemId)
      );
    } else {
      setSelected((prevSelectedApplicants) => [
        ...prevSelectedApplicants,
        itemId,
      ]);
    }
  };

  const orderByFunction = (item, index) => {
    const nameToUpperCase = item[0].toUpperCase() + item.slice(1);
    setOrderBy(nameToUpperCase);
    setTimeout(() => {
      const newOrderDir = orderDir === 'asc' ? 'desc' : 'asc';
      setOrderDir(newOrderDir);
      setArrowRotation(newOrderDir === 'desc' ? 'rotate-up' : '');

      tableData.refetch({
        pageNumber: page,
        orderDir: newOrderDir,
        orderBy: nameToUpperCase,
      });
    }, [500]);
  };

  const checkOrUncheck = () => {
    if (selected.length !== 0) {
      setIsAllChecked(true);
      setChecked((checked) => !checked);
      setSelected([]);
    } else {
      setIsAllChecked(false);
      const allItemsId = tableData.data?.items?.map((item) => item.id);
      setSelected(allItemsId);
    }
  };
  if (tableData.isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className={styles['container']}>
        <table className={styles['table-container']}>
          <thead>
            <tr>
              {checkBox ? (
                <th
                  className={styles['header-cell']}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    // src={isAllChecked ? checkeAllIcon : checkedicon}
                    src={checkedicon}
                    alt=''
                    onClick={checkOrUncheck}
                  />
                </th>
              ) : (
                ''
              )}

              {tableData.tableHeader &&
                tableData.tableHeader?.map((item, index) => {
                  if (columnVisibility) {
                    if (!visibleColumn[item.key]) {
                      return null;
                    }
                  }
                  return (
                    <th
                      className={
                        index === 0
                          ? `${styles.firstRadius} ${styles['header-cell']}`
                          : index === tableData?.tableHeader.length - 1 &&
                            !editAdd
                          ? `${styles.lastRadius} ${styles['header-cell']}`
                          : `${styles['header-cell']} `
                      }
                      key={item.key}
                    >
                      {item.title}
                      {orderDir && (
                        <img
                          src={leftArrow}
                          alt='icon'
                          className={`${styles['arrowIcon']} ${styles[arrowRotation]}`}
                          onClick={() => orderByFunction(item.key)}
                        />
                      )}
                    </th>
                  );
                })}
              {editAdd ? <th className={styles.lastRadius}></th> : ''}
            </tr>
          </thead>
          <tbody>
            {tableData.data?.items?.length > 0 ? (
              <>
                {tableData.data?.items?.map((item) => {
                  return (
                    <tr
                      key={item.id}
                      onClick={
                        handleRowClick
                          ? (e) => handleRowClick(e, item.id)
                          : undefined
                      }
                    >
                      {checkBox && (
                        <td
                          onClick={(e) => handleCheckboxClick(e, item.id)}
                          className={styles['tr-checkbox']}
                        >
                          <div
                            className={
                              selected?.includes(item.id)
                                ? styles['leftBorder']
                                : ''
                            }
                          >
                            <p></p>
                          </div>
                          <CheckBox
                            value={selected?.includes(item.id)}
                            onChange={() => toggleCheckUser(item.id)}
                          />
                        </td>
                      )}

                      {tableData.tableHeader?.map((header, i) => {
                        return (
                          <>
                            {columnVisibility ? (
                              <>
                                {' '}
                                {visibleColumn[header.key] && (
                                  <td
                                    key={header.key}
                                    style={{
                                      cursor: handleRowClick ? 'pointer' : '',
                                    }}
                                  >
                                    {header.flag === 'dublicate' ? (
                                      <span className={styles['dublicate']}>
                                        +{item[header.key]}
                                      </span>
                                    ) : (
                                      formatFunction(
                                        header.flag,
                                        item[header.key]
                                      )
                                    )}
                                  </td>
                                )}
                              </>
                            ) : (
                              <td>
                                {formatFunction(header.flag, item[header.key])}
                              </td>
                            )}
                          </>
                        );
                      })}
                      <td>
                        <div>
                          {editAdd ? (
                            <MoreButton icon={moreInfo} left='0'>
                              <PopOver
                                info={[
                                  {
                                    title: 'تعديل',
                                    icon: editSvg,
                                    handleFunction: () => handleEditClick(item),
                                  },
                                  {
                                    title: 'حذف',
                                    icon: deleteSvg,
                                    handleFunction: () => handleDelete(item),
                                  },
                                ]}
                              />
                            </MoreButton>
                          ) : (
                            // <InfoButton
                            //   icon={moreInfo}
                            //   tableClassName={styles["more-info"]}
                            //   data={[
                            //     {
                            //       label: "Edit",
                            //       icon: editSvg,
                            //       onClick: () => handleEditClick(item),
                            //     },
                            //     {
                            //       label: "Delete",
                            //       icon: deleteSvg,
                            //       onClick: () => handleDelete(item),
                            //     },
                            //   ]}
                            // />
                            ''
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <tr>
                <td colSpan={tableData?.tableHeader?.length + 1}>
                  {' '}
                  <NoDataComponent />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {pagination ? (
        <Pagination
          totalPages={totalPages}
          page={page}
          setPage={setPage}
          itemsPerPage={pageSize}
          setPageSize={setPageSize}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default TableComponent;
